import classNames from 'classnames';
import React from 'react';

import '@eika/button-style';

import { ButtonGroupProps } from './types';

const ButtonGroup: React.FC<ButtonGroupProps> = ({
    primaryAction,
    secondaryAction,
    hideSecondaryAction = false,
    tertiaryAction,
    hideTertiaryAction,
    className,
    ...rest
}) => {
    return (
        <div className={classNames('sgw-button-group', className, {})} {...rest}>
            <div className="sgw-button-group__first-row">
                {!hideSecondaryAction && Boolean(secondaryAction) && secondaryAction}
                {primaryAction}
            </div>
            {!hideTertiaryAction && Boolean(tertiaryAction) && (
                <div className="sgw-button-group__second-row">{tertiaryAction}</div>
            )}
        </div>
    );
};

export default ButtonGroup;
